// extracted by mini-css-extract-plugin
export default {"loadingWrap":"index_loadingWrap__g9mek"};